/* eslint-disable max-len */
import React from 'react';

const DateInput = ({ date, onDateChange, labeltext,patientDob ,idPrefix}) => {
    // Generate dynamic IDs based on the label text or serviceActivation prop
    const handleInputChange = (e, field) => {
        const value = e.target.value;
        onDateChange({ ...date, [field]: value });

        if(patientDob===true){
            if(field==='year' && value.length===4){
                document.getElementById(`${idPrefix}MonthInput`).focus();
            }
            else if(field==='month' && value.length===2){
                document.getElementById(`${idPrefix}DayInput`).focus();
            }
        }
        else {
            // Shift focus to the next field based on input length
            if (field === 'month' && value.length === 2) {
                document.getElementById(`${idPrefix}DayInput`).focus();
            } else if (field === 'day' && value.length === 2) {
                document.getElementById(`${idPrefix}YearInput`).focus();
            }
        }
        
    };

    return (
        <div>
            <label className='text-xs font-normal text-[#000000] mb-1 more-lines'>{labeltext}</label>
            <div className="flex items-center border border-[#C5C9DA] rounded-lg px-2 py-1.5">
                {patientDob && <>                
                    <input
                        id={`${idPrefix}YearInput`}
                        type="text"
                        maxLength="4"
                        placeholder="YYYY"
                        value={date.year || ''}
                        onChange={(e) => handleInputChange(e, 'year')}
                        autoComplete='off'
                        className="w-[40px] text-sm font-normal 
                    text-[#000000] disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-xs outline-none appearance-none pl-1"
                    />
                    /
                </>

                }
                <input
                    id={`${idPrefix}MonthInput`}
                    type="text"
                    maxLength="2"
                    placeholder="MM"
                    value={date.month || ''}
                    autoComplete='off'
                    onChange={(e) => handleInputChange(e, 'month')}
                    className="w-[26px] text-sm font-normal 
                    text-[#000000] disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-xs outline-none appearance-none pl-0.5"
                />
                /
                <input
                    id={`${idPrefix}DayInput`}
                    type="text"
                    maxLength="2"
                    placeholder="DD"
                    value={date.day || ''}
                    onChange={(e) => handleInputChange(e, 'day')}
                    autoComplete='off'
                    className="w-[30px] text-sm font-normal 
                    text-[#000000] disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-xs outline-none appearance-none pl-1"
                />
                {!patientDob && <>       
                    /         
                    <input
                        id={`${idPrefix}YearInput`}
                        type="text"
                        maxLength="4"
                        placeholder="YYYY"
                        value={date.year || ''}
                        onChange={(e) => handleInputChange(e, 'year')}
                        autoComplete='off'
                        className="w-[60px] text-sm font-normal 
                    text-[#000000] disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-xs outline-none appearance-none pl-1"
                    />
                    
                </>

                }
                
            </div>
        </div>
    );
};

export default DateInput;
